export default "__VITE_ASSET__DvH6BfZz__"